import { OCULTO_ENVIRONMENT, PRODUCTION_ENVIRONMENT } from '../../../constants';
import { API_MIGRATION_STATE, MIGRATION_STATE } from '../migrationUsersBranchView.constants';

export const getDocumentLink = path => {
  if (window.__ENV__ === PRODUCTION_ENVIRONMENT || window.__ENV__ === OCULTO_ENVIRONMENT) {
    return `${window.MIDDLEWARE_CMS_BASE_HOST}${path}`
      .replace('.stg.mb.', '.')
      .replace('.es/', '.de/');
  } else {
    return `${window.MIDDLEWARE_CMS_BASE_HOST}${path}`.replace('.mb.', '.').replace('.es/', '.de/');
  }
};

export const hasBannerForMigration = migrationState =>
  [
    API_MIGRATION_STATE.ALLOW_MIGRATION,
    API_MIGRATION_STATE.SIGNED_CONTRACT,
    API_MIGRATION_STATE.VIDEOCALL_KO,
    API_MIGRATION_STATE.VIDEOCALL_SUCCESS,
    API_MIGRATION_STATE.REJECTED_MIGRATION,
    API_MIGRATION_STATE.MIGRATION_STARTED,
  ].includes(migrationState);

export const isFlowMigrationAllowed = migrationState =>
  [
    API_MIGRATION_STATE.ALLOW_MIGRATION,
    API_MIGRATION_STATE.SIGNED_CONTRACT,
    API_MIGRATION_STATE.VIDEOCALL_KO,
    API_MIGRATION_STATE.VIDEOCALL_SUCCESS,
    API_MIGRATION_STATE.REJECTED_MIGRATION,
    API_MIGRATION_STATE.MIGRATION_STARTED,
  ].includes(migrationState) || window.location.search.includes('?identificationResult=');

export const getFlowStep = status =>
  ({
    [API_MIGRATION_STATE.ALLOW_MIGRATION]: MIGRATION_STATE.INITIAL,
    [API_MIGRATION_STATE.REJECTED_MIGRATION]: MIGRATION_STATE.INITIAL,
    [API_MIGRATION_STATE.MIGRATION_STARTED]: MIGRATION_STATE.TERMS_AND_CONDITIONS,
    [API_MIGRATION_STATE.SIGNED_CONTRACT]: MIGRATION_STATE.VIDEOCALL_INFO,
    [API_MIGRATION_STATE.VIDEOCALL_KO]: MIGRATION_STATE.VIDEOCALL_INFO,
    [API_MIGRATION_STATE.VIDEOCALL_SUCCESS]: MIGRATION_STATE.MIGRATION_SUCCESS,
  }[status] || MIGRATION_STATE.INITIAL);

export const isAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false;
  return (
    (/android/i.test(navigator.userAgent) && /wv/i.test(navigator.userAgent)) ||
    /ok.webview\/Android/i.test(navigator.userAgent)
  );
};

export const isIosWebView = () => {
  if (typeof navigator === 'undefined') return false;
  return (
    (/iPad|iPhone|iPod/i.test(navigator.userAgent) &&
      !/safari/i.test(navigator.userAgent) &&
      !window.MSStream) ||
    /ok.webview\/iOS/i.test(navigator.userAgent)
  );
};

export const isItWebViewPlatform = () => isAndroidWebView() || isIosWebView();

export const goToGP = history =>
  isItWebViewPlatform()
    ? (window.location.href = '/myprofile/global/')
    : history.push('myprofile/global');
